<template>
  <div class="isman">
    <router-view></router-view>
    <enfold class="enfo">
      <div class="play_list" id="playlist" ref="playlist">
        <div class="choose" ref="button" id="choose">
          <div class="buton play_plan" :class="{trans:playPlan,transback:isBack}" @click="playplan">
            <div><span>{{$t('schedule.loop')}}</span></div>
          </div>
          <div class="buton time_plan" :class="{trans:timePlan,transback:isBack}" @click="timeplan">
            <span>{{$t('schedule.timpingPlay')}}</span>
          </div>
          <div class="buton urgency_plan" :class="{trans:urgencyPlan,transback:isBack}" @click="urgencyplan">
            <span>{{$t('schedule.emerPlay')}}</span>
          </div>
        </div>
        <div class="listbutton" @click="opentabel" id="control">
          <span>{{$t('schedule.releaseRecord')}}</span>
          <img src="~@/assets/images/public/icon_arrow.png" class="deg" :class="{deg90:!btstyle}" />
        </div>

        <play-list-table class="tab" ref="mytable" id="botto"></play-list-table>

        <div class="local"><span>{{$t('schedule.releaseMan')}}</span></div>
      </div>
    </enfold>
  </div>
</template>

<script>
const animateTime = 200; //中间三个按钮的动画时间 实际上一共需要 animateTime*2 ms //还要修改css的时间
import PlayListTable from './PlayListTable.vue'
import Enfold from '@/components/basics/Enfold'
export default {
  name: 'IssueManage',
  components: {
    PlayListTable,
    Enfold
  },
  data() {
    return {
      drawer: false,
      isAppear: false,
      btstyle: true,
      playPlan: false,
      timePlan: false,
      urgencyPlan: false,
      isBack: false
    }

  },
  methods: {
    playplan() {
      this.playPlan = true;
      setTimeout(() => {
        this.isBack = true;
      }, animateTime)
      setTimeout(() => {
        this.$router.push({
          name: 'PlayList',
          params: {
            plan_type: 0
          }
        })
      }, animateTime * 2)
    },
    timeplan() {
      this.timePlan = true;
      setTimeout(() => {
        this.isBack = true;
      }, animateTime)
      setTimeout(() => {
        this.$router.push({
          name: 'PlayList',
          params: {
            plan_type: 1
          }
        })
      }, animateTime * 2)
    },
    urgencyplan() {
      // this.$router.push({
      // 	path: 'playList',
      // 	query: {
      // 		plan_type: 2
      // 	}
      // })
      this.urgencyPlan = true;
      setTimeout(() => {
        this.isBack = true;
      }, animateTime)
      setTimeout(() => {
        this.$router.push({
          name: 'PlayList',
          params: {
            plan_type: 2
          }
        })
      }, animateTime * 2)
    },
    opentabel() {
      this.btstyle = !this.btstyle
      let botto = document.getElementById('botto')
      let control = document.getElementById('control')
      let choose = document.getElementById('choose')
      //let play_list = document.getElementById('playlist')
      this.isAppear = !this.isAppear
      if (this.isAppear == true) {
        document.getElementById('playlist').className = 'play_list_up';
        let height = -52
        let control_height = 0
        let choose_height = 36
        //let opacity = 0
        let timer = setInterval(function () {
          //上浮的按钮和表格
          if (botto.style.bottom == "0%") {
            clearInterval(timer);
          } else {
            height++
            control_height++
            botto.style.bottom = height + '%'
            control.style.bottom = control_height + '%'
          }
          //中间的三个button
          if (choose.style.top == '18%') {
            //console.log('')
          } else {
            choose_height--
            choose.style.top = choose_height + '%'
          }

        }, 10);
      } else {
        document.getElementById('playlist').className = 'play_list_down'
        let height = 0
        let control_height = 52
        let choose_height = 18
        let opacity = 0.488
        let timer1 = setInterval(function () {
          if (botto.style.bottom == "-52%") {
            clearInterval(timer1);
          } else {
            opacity = opacity - 0.008
            height--
            control_height--
            botto.style.bottom = height + '%'
            control.style.bottom = control_height + '%'
          }

          if (choose.style.top == "36%") {
            //console.log('')
          } else {
            choose_height++
            choose.style.top = choose_height + '%'
          }

        }, 10);
      }


    }
  }
}
</script>

<style lang="scss" scoped>
.deg {
  transform: rotateZ(0deg);
  transition: all 1000ms;
}

.deg90 {
  transform: rotateZ(180deg);
}
.isman {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.play_list {
  width: 100%;
  height: 100%;
  position: relative;
  /* margin: 1% auto; */
  background-color: #ffffff;
  animation: defau 1.5s 1;
  overflow: hidden;
}

.play_list_up {
  width: 100%;
  height: 100%;
  position: relative;
  /* margin: 0 auto; */
  background-color: rgba(126, 192, 233, 0.45);
  animation: mymove 1.5s 1;
  overflow: hidden;
}

.play_list_down {
  width: 100%;
  height: 100%;
  position: relative;
  /* margin: 1% auto; */
  background-color: #ffffff;
  animation: movedown 1.5s 1;
  overflow: hidden;
}

@keyframes defau {
  from {
    background-color: #ffffff;
  }

  to {
    background-color: #ffffff;
  }
}

@keyframes mymove {
  from {
    background-color: #ffffff;
  }

  to {
    background-color: rgba(126, 192, 233, 0.45);
  }
}

@keyframes movedown {
  from {
    background-color: rgba(126, 192, 233, 0.45);
  }

  to {
    background-color: #ffffff;
  }
}

.choose {
  width: 52vw;
  height: 13vw;
  min-height: 150px;
  min-width: 600px;
  /* border: 1px solid black; */
  display: flex;
  justify-content: space-between;
  position: absolute;
  left: 50%;
  top: 36%;
  transform: translate(-50%, -50%);
}

.choosetop {
  width: 52vw;
  height: 13vw;
  /* border: 1px solid black; */
  display: flex;
  justify-content: space-between;
  margin: 1% auto;
}

.buton {
  width: 13vw;
  min-width: 150px;
  height: 100%;
  background-size: 100%;
  background-position: center;
  position: relative;
  transition: transform 200ms;
}
.trans {
  z-index: 9;
  transform: scale(1.5, 1.5);
}
.transback {
  transform: scale(1, 1);
}

.buton:hover {
  cursor: pointer;
}

.buton span {
  position: absolute;
  white-space: nowrap;
  bottom: 28%;
  left: 50%;
  transform: translate(-50%);
  color: #f1fcff;
}

.play_plan {
  background-image: url(~@/assets/images/release/btn_cycle.png);
}

.time_plan {
  background-image: url(~@/assets/images/release/btn_timing.png);
}

.urgency_plan {
  background-image: url(~@/assets/images/release/btn_urgent.png);
}

.listbutton {
  /* border: 1px solid black; */
  //height: 2vw;
  //width: 10vw;
  display: flex;
  cursor: pointer;
  padding: 4px;
  justify-content: space-around;
  background-image: linear-gradient(
      270deg,
      #86eae7 0%,
      #4cccf0 45%,
      #11adf8 100%
    ),
    linear-gradient(#3e8ce6, #3e8ce6);
  background-blend-mode: normal, normal;
  border-radius: 15px 15px 0vw 0vw;
  position: absolute;
  /* display: table-cell;
		vertical-align: middle; */
  padding: 0 10px;
  right: 5%;
  bottom: 0;
}

.listbutton span {
  font-family: MicrosoftYaHei;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 30px;
  color: #ffffff;
}

.listbuttontop {
  border: 1px solid black;
  height: 35px;
  width: 100px;
  position: absolute;
  right: 5%;
  bottom: 60%;
}

.tab {
  position: absolute;
  left: 50%;
  bottom: -60%;
  transform: translate(-50%);
}

.local {
  position: fixed;
  left: 0;
  padding: 2px 6px 2px 6px;
  bottom: 3%;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 0vw 15px 15px 0vw;
  text-align: center;
  box-shadow: 0 0 5px 1px #999;
}

.local span {
  font-family: PingFang-SC-Regular;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  line-height: 30px;
  letter-spacing: 0vh;
  color: rgba(47, 179, 255, 1);
}
</style>
